/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { Box, useThemeValue } from '@altermaind/web/ui';

type Props = {
  onClick: (idx: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
  DEFAULT_ITEMS_SIZE: number;
  slide: number;
};

export const NavigationForChart: FC<Props> = ({ onClick, data, DEFAULT_ITEMS_SIZE, slide }) => {
  const primaryColor = useThemeValue('colors', 'primary');

  return (
    <Box mt='s' display='flex' justifyContent='center'>
      {Array.from({ length: Math.ceil(data.length / DEFAULT_ITEMS_SIZE) }).map((_, idx) => (
        <Box
          style={{
            cursor: 'pointer',
          }}
          mx='xxxxs'
          key={idx}
          onClick={() => onClick(idx)}
          width='s'
          height='s'
        >
          <Box
            width='xxs'
            height='xxs'
            borderRadius='xxl'
            style={{
              backgroundColor: slide === idx ? primaryColor : '#ccc',
              border: 'none',
              display: 'inline-block',
            }}
          />
        </Box>
      ))}
    </Box>
  );
};
